import { createFileRoute } from "@tanstack/react-router";

import { useUser } from "@/web/auth/useUser";
import { Redirect } from "@/web/components/Redirect";

export const Route = createFileRoute("/_protected/profile/")({
  component: ProfileIndex,
});

function ProfileIndex() {
  const user = useUser();
  if (!user) {
    return null;
  }
  const hasSmb = user.brandIds.length > 0;
  const hasInv = user.investorIds.length > 0;

  if (hasSmb && !hasInv) return <Redirect to="/profile/smb" replace />;
  if (hasInv && !hasSmb) return <Redirect to="/profile/inv" replace />;
  // No profile yet (hasn't completed onboarding) — send to onboarding rather
  // than the SMB dashboard. Landing a brandless user on /profile/smb subscribes
  // them to `card_engine_inputs`, which has no brand to render.
  if (!hasSmb && !hasInv) return <Redirect to="/onboarding/smb" replace />;
  // Both profiles exist — default to SMB dashboard.
  return <Redirect to="/profile/smb" replace />;
}
